"use client"

import { useQuoteFetching } from "@/shared/hooks/use-quote-fetching"

export function PageClient({
  searchParams,
}: {
  searchParams: { [key: string]: string | string[] | undefined }
}): null {
  useQuoteFetching(searchParams)
  return null
}
